import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
import { Property, PropertyTypes } from "@ploy-lib/types";
import {
	HouseOwnerEntity,
	LienEntity,
	SpecialConstraintEntity
} from "../entities/ApplicationPropertyEntities";

export class ApplicationPropertiesResource
	extends BaseResource
	implements Property
{
	applicationPropertyId: number = 0;
	applicationId: number = 0;
	propertyInformation: string = "";
	uniquePropertyId: string = "";
	type: PropertyTypes = "Unknown";
	cadastralNumber: string = "";
	municipalityNumber: number = 0;
	cadastralUnitNumber: number = 0;
	unitNumber: number = 0;
	leaseholdUnitNumber: number = 0;
	sectionNumber: number = 0;
	housingCooperativeName: string = "";
	housingCooperativeOrgNumber: string = "";
	housingCooperativeAccountant: string = "";
	shareNumber: number = 0;
	streetName: string = "";
	addressNumber: number = 0;
	addressLetter: string = "";
	postalCode: string = "";
	postalPlace: string = "";
	freeText?: string = "";
	apartmentNumber?: string = "";
	businessManager?: string = "";
	housingCooperativeOrgName?: string = "";
	refinance: boolean = false;
	valueEnteredByCustomer: number = 0;
	ownedByOthers: boolean = false;
	estimatedValue: number = 0;
	jointDebt: number = 0;
	eAppraisal: number = 0;
	pledgeValue?: number = 0;
	utilizedValue: number = 0;
	utilizedSecurityValue: number = 0;
	eAppraisalReference: string = "";
	eAppraisalDate?: Date = undefined;
	mainCustomerResidence: boolean = false;
	useType: string = "";
	owners: HouseOwnerEntity[] = [];
	newOwners: HouseOwnerEntity[] = [];
	liens: LienEntity[] = [];
	newLiens?: LienEntity[] = [];
	specialConstraints: SpecialConstraintEntity[] = [];
	deleted?: boolean | undefined = undefined;

	static schema = {
		liens: [LienEntity],
		newLiens: [LienEntity],
		owners: [HouseOwnerEntity],
		newOwners: [HouseOwnerEntity],
		specialConstraints: [SpecialConstraintEntity]
	};

	pk() {
		return this.applicationPropertyId?.toString();
	}

	static urlRoot = apiResourceUrl("property/{applicationId}");
}
